//import 'assets/css/style.css'
import 'assets/css/style-main.css'
import './App.css'

import 'font-awesome/css/font-awesome.min.css'
import 'jquery/src/jquery'
import 'bootstrap/dist/js/bootstrap.min.js'

import { injectGlobal } from 'styled-components';
import pastelTtf from 'assets/css/fonts/pastel_crayon_0-webfont.ttf';
import pastelWoff from 'assets/css/fonts/pastel_crayon_0-webfont.woff';
import pastelEot from 'assets/css/fonts/pastel_crayon_0-webfont.eot';
import pastelEotIe from 'assets/css/fonts/pastel_crayon_0-webfont.eot?#iefix';
import pastelSvg from 'assets/css/fonts/pastel_crayon_0-webfont.svg';

import gsbTtf from 'assets/css/fonts/33447d8d-d920-48e7-b0a9-1d3dda80d6a6.ttf';
import gsbWoff from 'assets/css/fonts/2bc69477-90c2-4415-a51f-36e36eee3d5e.woff';
import gsbEot from 'assets/css/fonts/2cebe80c-b289-4ae0-a3b0-baa82c6c6e10.eot';
import gsbEotIe from 'assets/css/fonts/2cebe80c-b289-4ae0-a3b0-baa82c6c6e10.eot?#iefix';
import gsbSvg from 'assets/css/fonts/e49c440c-7653-44ce-96d2-f775947ba9fe.svg';

injectGlobal`
  @font-face {
    font-family: 'pastelregular';
    src:url(${pastelEot});
    src:url(${pastelEotIe}) format('embedded-opentype'),
        url(${pastelWoff}) format('woff'),
        url(${pastelTtf}) format('truetype'),
        url(${pastelSvg}) format('svg');
    font-weight:400;
    font-style:normal;
  }
  @font-face {
    font-family:"Gill Sans W01 Book";
    src:url(${gsbEot});
    src:url(${gsbEotIe}) format('embedded-opentype'),
        url(${gsbWoff}) format("woff"),
        url(${gsbTtf}) format("truetype"),
        url(${gsbSvg}) format("svg")
  }
`